var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 45,
        "min-height": 55,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _vm._t("text-title"),
          ],
          2
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("advance-receipt-detail", {
            attrs: {
              "disable-change": _vm.entity.isNew,
              "show-amount": _vm.showAmount,
              "read-only-view": _vm.readOnlyView,
            },
            model: {
              value: _vm.entity,
              callback: function ($$v) {
                _vm.entity = $$v
              },
              expression: "entity",
            },
          }),
        ],
        1
      ),
      _c(
        "footer",
        {
          staticClass: "modal-card-foot",
          style: `justify-content: flex-${_vm.buttonLocation}`,
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.entity.isNew,
                  expression: "entity.isNew",
                },
              ],
              staticClass: "button is-success tooltip",
              attrs: { "data-tooltip": "Save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Save")]
          ),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.entity.isNew,
                  expression: "!entity.isNew",
                },
              ],
              staticClass: "button is-success tooltip",
              attrs: { "data-tooltip": "Print" },
              on: {
                click: function ($event) {
                  return _vm.print()
                },
              },
            },
            [_vm._v("Print")]
          ),
          _c(
            "button",
            {
              staticClass: "button tooltip",
              attrs: { "data-tooltip": "Cancel" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }